import { tituloClinico } from "../../../utils/textoClinico";
import { montoLegible } from "../../../utils/facturaCrear";
import { detallesDe, importePromocion } from "../../../utils/panelAgregar";

/* ============================================================================
   PANEL DE AGREGAR · fila de promoción

   Una promoción es un GRUPO, no un procedimiento: la mayor del sistema trae 44
   exámenes. Marcarla mete el grupo completo, así que la fila TIENE que poder
   abrirse para ver qué entra -- agregar 44 líneas a ciegas no es una decisión
   informada.

   Se elige UNA a la vez. El modal viejo rechazaba explícitamente más de una y
   esa regla no se toca; aquí se expresa con una casilla que se comporta como
   un radio en vez de con un aviso después de pulsar.
   ========================================================================== */

function Check({ marcada }) {
    return (
        <span className={`pag__check${marcada ? " is-marcada" : ""}`} aria-hidden="true">
            {marcada && (
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 6L9 17l-5-5" />
                </svg>
            )}
        </span>
    );
}

function Chevron({ abierta }) {
    return (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
             style={{ transform: abierta ? "rotate(90deg)" : "none", transition: "transform .15s" }}>
            <path d="M9 6l6 6-6 6" />
        </svg>
    );
}

export default function FilaPromocion({ promo, marcada, onAlternar, abierta, onAbrir }) {
    const detalles = detallesDe(promo);
    const nombre = tituloClinico(promo?.nombre ?? "");
    const total = importePromocion(promo);

    return (
        <div className={`pag__promo${marcada ? " is-marcada" : ""}`}>
            <div className="pag__promo-fila">
                <label className="pag__promo-elegir">
                    <input
                        type="checkbox"
                        className="pag__check-input"
                        checked={marcada}
                        onChange={() => onAlternar(promo)}
                        aria-label={`${marcada ? "Quitar" : "Elegir"} la promoción ${nombre}`}
                    />
                    <Check marcada={marcada} />
                </label>

                <span className="pag__proc">
                    <span className="pag__proc-nombre" title={nombre}>{nombre || "—"}</span>
                    <span className="pag__proc-meta">
                        <span className="pag__codigo">
                            {detalles.length} procedimiento{detalles.length === 1 ? "" : "s"}
                        </span>
                        {promo?.Seguros?.nombre && (
                            <span className="pag__tag pag__tag--info">
                                {tituloClinico(promo.Seguros.nombre)}
                            </span>
                        )}
                    </span>
                </span>

                {/* Abrir NO elige la promoción: son dos acciones distintas y un
                    clic para mirar no debe agregar 44 líneas. */}
                <button
                    type="button"
                    className="pag__promo-abrir"
                    onClick={() => onAbrir(promo)}
                    aria-expanded={abierta}
                    aria-label={`${abierta ? "Ocultar" : "Ver"} los procedimientos de ${nombre}`}
                    data-testid={`panel-promo-abrir-${promo?.id_promocion}`}
                >
                    <Chevron abierta={abierta} />
                    {abierta ? "Ocultar" : "Ver qué trae"}
                </button>

                <span className="pag__precio">${montoLegible(total)}</span>
            </div>

            {abierta && (
                <ul className="pag__promo-detalle" data-testid={`panel-promo-detalle-${promo?.id_promocion}`}>
                    {detalles.length === 0 && (
                        <li className="pag__promo-vacio">Esta promoción no tiene procedimientos.</li>
                    )}
                    {detalles.map((d) => (
                        <li key={d.id_tipo_examen}>
                            <span className="pag__promo-detalle-nombre">
                                {tituloClinico(d?.ExamenTipo?.descripcion ?? "")}
                            </span>
                            <span className="pag__codigo">{d?.ExamenTipo?.codigo}</span>
                            <span className="pag__promo-detalle-precio">
                                ${montoLegible(d?.precio_promocion)}
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
